import { z } from 'zod';
import { revenueBrandSchema } from '../revenueBrand.js';
import { subscriptionBillingCadenceSchema } from './subscriptionBillingCadence.js';
import { subscriptionPaymentMethodSchema } from './subscriptionPaymentMethod.js';
export const cadenceAmountsSchema = z.object({
    firstPayment: z.string(),
    commitmentTotal: z.string(),
});
export const subscriptionPlanCatalogueEntrySchema = z.object({
    id: z.number().int(),
    uuid: z.uuid(),
    name: z.string(),
    commitmentLengthInMonths: z.number().int(),
    pricePerMonth: z.string(),
    // Set when the whole term is not simply the monthly price multiplied out.
    upfrontPrice: z.string().nullable(),
    cadences: z.array(subscriptionBillingCadenceSchema),
    paymentMethods: z.array(subscriptionPaymentMethodSchema),
    // The brands this plan can be invoiced for. Empty when it is not sold on invoice.
    revenueBrands: z.array(revenueBrandSchema),
});
export const pricedSubscriptionPlanSchema = subscriptionPlanCatalogueEntrySchema.extend({
    amountsByCadence: z.partialRecord(subscriptionBillingCadenceSchema, cadenceAmountsSchema),
});
